<template>
  <div class="container mt-3 mb-4">
    <div class="row text-center mb-4">
      <div class="col">
        <small class="text-uppercase">A partnership between</small>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ul class="d-flex flex-wrap justify-content-center text-center list-unstyled">
          <li class="mx-4 mb-5">
            <a href="https://personal-finance.bnpparibas/en/"><img src="../assets/img/logo-BNPP-PF.png"  height="50px" class="" alt=""></a>
          </li>
          <li class="mx-4 mb-5">
            <a href="https://www.telecom-paris.fr/en/home"><img src="../assets/img/logo-telecom-paristech.png"  height="50px" class="" alt=""></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sponsors"
};
</script>

<style>
</style>